<template>
  <!-- <div class="overlay"></div> -->
  <div class="chat-area">
    <template v-if="messages.length == 0">
      <div class="welcome">
        <div>
          <img src="favicon.png" alt="DeepSeek Logo" class="welcome-logo" />
          <div class="welcome-message">
            <div class="model-name">嗨！我是宣传舆论AI服务智能体</div>
          </div>
        </div>
        <p>我可以帮你搜索、写稿、审核、制作新媒体……<br />请把你的任务交给我吧</p>
      </div>
      <!-- <div class="question">
        <p>这是一个关于禁毒知识的问答模型，请问您有什么想问的吗？</p>
        <p>
          <span @click="questionClick(item)" v-for="item in question" :key="item">{{ item }}</span>
        </p>
      </div> -->
    </template>

    <div class="content" ref="content" v-else>
      <div>
        <div v-for="(msg, index) in messages" :key="index" class="message">
          <div v-if="msg.role === 'user'" class="user-message">
            <div class="message-content user-message-content">{{ msg.content }}</div>
            <img src="favicon.png" alt="User" class="avatar" />
          </div>
          <div v-if="msg.role === 'assistant'" class="bot-message">
            <img :src="avatar_bot" alt="Bot" class="avatar" />
            <div class="message-content bot-message-content">
              <template v-if="loading && index == messages.length - 1"><i></i><i></i><i></i></template>
              <div class="reasoning_content" v-if="msg.reasoning_content">
                {{ msg.reasoning_content }}
              </div>
              <div class="assistant_content" v-if="msg.content">
                {{ msg.content }}
              </div>
            </div>
          </div>
        </div>
        <div @click="restart" class="restart"><i class="el-icon-refresh"></i>开启新的对话</div>
      </div>
    </div>

    <div class="chat-input">
      <div class="input-content">
        <textarea name="message" v-model="input" placeholder="欢迎体验DeepSeek..." @input="textInput" @keyup.enter="sendMessage" :style="'height:' + inputHeight + 'px'" class="input-field"></textarea>
      </div>
      <div class="input-features">
        <!-- <div class="web-search-toggle">
          <img
            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20fill='none'%20viewBox='0%200%2024%2024'%20stroke-width='1.75'%20stroke='currentColor'%20class='size-5'%3e%3cpath%20stroke-linecap='round'%20stroke-linejoin='round'%20d='M12%2021a9.004%209.004%200%200%200%208.716-6.747M12%2021a9.004%209.004%200%200%201-8.716-6.747M12%2021c2.485%200%204.5-4.03%204.5-9S14.485%203%2012%203m0%2018c-2.485%200-4.5-4.03-4.5-9S9.515%203%2012%203m0%200a8.997%208.997%200%200%201%207.843%204.582M12%203a8.997%208.997%200%200%200-7.843%204.582m15.686%200A11.953%2011.953%200%200%201%2012%2010.5c-2.998%200-5.74-1.1-7.843-2.918m15.686%200A8.959%208.959%200%200%201%2021%2012c0%20.778-.099%201.533-.284%202.253m0%200A17.919%2017.919%200%200%201%2012%2016.5c-3.162%200-6.133-.815-8.716-2.247m0%200A9.015%209.015%200%200%201%203%2012c0-1.605.42-3.113%201.157-4.418'%3e%3c/path%3e%3c/svg%3e"
            alt="search" /><span>联网搜索</span>
        </div>
        <div class="web-search-toggle">
          <img
            src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='128'%20height='128'%20viewBox='0%200%2024%2024'%3e%3cpath%20fill='%23000000'%20fill-rule='evenodd'%20d='M11.094%202.064a.61.61%200%200%201%20.318.542v5.153a.61.61%200%200%201-.236.482L9.488%209.547c.794.553%201.924%201.336%201.924%202.453c0%201.183-1.03%202.018-1.954%202.536l1.7%201.206c.16.117.254.3.254.5v5.153c0%20.224-.118.43-.312.535a.58.58%200%200%201-.606-.035l-6.471-4.541a3.26%203.26%200%200%201-1.436-2.624c0-.747.33-1.647%201.43-2.706c-.841-.718-1.43-1.588-1.43-2.753c0-1.394%201.618-2.589%202.612-3.23l5.277-3.924a.59.59%200%200%201%20.618-.053M5.082%207.612c-.43.353-1.318%201.018-1.318%201.659c0%20.894.541%201.447%201.176%201.97l1.765-1.158l1.177.706l-1.953%201.206l2.423%201.747c.648-.277%201.883-.883%201.883-1.742c0-.911-1.447-1.476-2.088-1.917c-1.018-.706-2.406-1.365-3.06-2.471zm-.118%205.159c-1.07.976-1.2%201.63-1.2%201.959c0%20.43.218%201.135.912%201.618h.006l.5.353a3.28%203.28%200%200%201%201.882-1.924l.87.859c-.705.318-1.435.959-1.57%201.265a1.2%201.2%200%200%200-.106.553l3.977%202.794v-3.689a669%20669%200%200%201-5.271-3.788m1.082-5.865c.4.859%201.665%201.424%202.406%201.93l1.783-1.383V3.794L6.046%206.912zM12.9%202.07a.58.58%200%200%201%20.6.03l6.177%204.247c1.03.7%201.735%201.612%201.735%202.924c0%201.076-.676%201.982-1.412%202.682c.647.53%201.412%201.412%201.412%202.777c0%201.706-1.241%202.524-2.059%203.059l-.265.17c-.447.312-3.911%202.742-5.576%203.936a.58.58%200%200%201-.606.035a.61.61%200%200%201-.318-.535v-5.153c0-.188.088-.37.235-.483l1.653-1.276c-.917-.57-1.888-1.224-1.888-2.483c0-1.105%201.135-1.964%201.912-2.547l-1.659-1.2a.61.61%200%200%201-.253-.494V2.606a.59.59%200%200%201%20.312-.53zm2.624%208.119c-.453.329-1.76%201.105-1.76%201.811c0%20.977%201.436%201.518%202.066%201.906l.023.012c1.106.76%202.488%201.406%203.212%202.606c.682-.476%201.17-.923%201.17-1.794c0-.959-.605-1.565-1.164-1.982l-1.777%201.376l-1.176-.606l1.941-1.5l-2.53-1.824zm3.5%201.047l-5.26-3.795V3.735l3.795%202.606c.618.424-1.2%201.824-1.441%202.024l1.176.606c.66-.547%201.153-.918%201.453-1.812l.283.194c.688.47%201.206%201.018%201.206%201.918c0%20.8-.671%201.47-1.212%201.965m-.942%205.959c-.529-.941-1.688-1.447-2.529-2.03l-1.788%201.383v3.688l4.323-3.041z'%20clip-rule='evenodd'/%3e%3c/svg%3e"
            alt="search" /><span>深度思考</span>
        </div> -->
        <div class="action-buttons" @click="sendMessage">
          <i v-if="loading || isOutput"></i>
          <img v-else src="../assets/start.png" class="disabled" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      inputHeight: 100,
      question: ["毒品常识", "常见毒品", "毒品的危害", "如何防范毒品", "防范毒品小贴士"],

      input: "",
      messages: [],
      avatar_bot: require("@/assets/jiqr.png"),
      loading: false,
      isOutput: false,
      controller: undefined,

      isfollow: false, //滚动条是否跟随
      followStatus: false, //滚动条触发来源 false手动 true自动
    };
  },
  mounted() {},
  created() {},
  methods: {
    textInput(e) {
      this.inputHeight = e.target.scrollHeight;
    },
    questionClick(input) {
      this.input = input;
      this.sendMessage();
    },
    sendMessage() {
      if (this.loading || this.isOutput) {
        this.controller.abort();
        this.messages[this.messages.length - 1].reasoning_content = "";
        this.messages[this.messages.length - 1].content = "停止作答";
        this.loading = false;
        this.isOutput = false;

        return;
      }

      if (this.input == "") {
        this.$message("请输入内容");
        return;
      }

      this.messages.push(
        {
          role: "user",
          content: this.input,
        },
        {
          role: "assistant",
          content: "",
        }
      );

      this.start();
      const signal = this.controller.signal;

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer b7ffa3db-befd-4fee-b108-d88a8f26feee",
        },
        body: JSON.stringify({
          messages: this.messages.slice(0, this.messages.length - 1),
          model: "deepseek-v3-250324",
          stream: true,
        }),
        signal: signal,
      };
      this.input = "";

      fetch("https://ark.cn-beijing.volces.com/api/v3/chat/completions", requestOptions)
        .then((response) => {
          if (response.ok) {
            return response.body;
          }

          throw new Error("Network response was not ok.");
        })
        .then((body) => {
          const reader = body.getReader();
          const decoder = new TextDecoder();
          var content = "",
            reasoning_content = "",
            read = () => {
              return reader.read().then(({ done, value }) => {
                if (done) {
                  // 读取完成
                  this.isOutput = false;
                  return;
                }
                var text = decoder.decode(value).split("\n\n");
                for (var i = 0; i < text.length - 1; i++) {
                  if (text[i].search(/\[DONE\]/) == -1) {
                    var data;
                    try {
                      eval(text[i].replace(":", "="));
                    } catch {
                      continue;
                    }
                    content += data.choices[0].delta.content;
                    reasoning_content += data.choices[0].delta.reasoning_content ? data.choices[0].delta.reasoning_content : "";
                  } else {
                    this.isOutput = false;
                  }
                }

                this.$set(this.messages[this.messages.length - 1], "content", content);
                this.$set(this.messages[this.messages.length - 1], "reasoning_content", reasoning_content);
                if (this.isfollow)
                  this.$nextTick(() => {
                    this.$refs.content.scrollTop = this.$refs.content.scrollHeight - this.$refs.content.clientHeight;
                    this.followStatus = true;
                  });
                this.loading = false;
                return read();
              });
            };
          return read();
        })
        .catch((error) => {
          // 处理错误
          console.error("Error:", error);
        });
    },
    start() {
      this.loading = true;
      this.isOutput = true;
      this.isfollow = true;
      this.controller = new AbortController();

      var scrollContent = () => {
        if (!this.isOutput) {
          this.$refs.content.removeEventListener("scroll", scrollContent);
        }

        if (this.followStatus) {
          //js 触发滚动
          this.followStatus = !this.followStatus;
        } else {
          //手动 触发滚动
          this.isfollow = false;
        }
      };

      this.$nextTick(() => {
        this.$refs.content.addEventListener("scroll", scrollContent);
      });
    },

    restart() {
      this.controller.abort();
      this.messages = [];
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.chat-area {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.welcome {
  font-size: 28px;
  margin: auto 0 50px;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .welcome-logo {
    height: 46px;
    margin-right: 20px;
  }
  > p {
    font-size: 20px;
    margin-top: 40px;
    color: #7b7a7a;
    text-align: center;
  }
}

.content {
  width: 80%;
  margin: 30px 0;
  border-radius: 20px;
  background: #fff;
  padding: 20px;
  border: 1px solid #e5e6eb;
  box-shadow: 0 4px 8px #0000000d;
  flex: 1;
  flex-basis: 0;
  overflow: auto;
  .message {
    > div {
      display: flex;
      align-items: flex-start;
      margin-bottom: 20px;
      > div {
        background: #eff6ff;
        margin: 0 20px;
        padding: 10px;
        border-radius: 10px;
        max-width: 70%;
        word-break: break-all;
      }
      img {
        flex-shrink: 0;
        width: 50px;
        border-radius: 50%;
      }
    }

    .user-message {
      justify-content: flex-end;
    }

    .bot-message {
      i {
        background-color: #0e3489;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin: 0 3px;
        display: inline-block;
      }
      i:first-child {
        animation: zoomLoad1 1s infinite;
      }
      i:nth-child(2) {
        animation: zoomLoad2 1s linear infinite;
      }
      i:nth-child(3) {
        animation: zoomLoad3 1s linear infinite;
      }
      @keyframes zoomLoad1 {
        0% {
          transform: scale(1);
        }
        25% {
          transform: scale(1.5);
        }
        50% {
          transform: scale(1);
        }
        100% {
          transform: scale(1);
        }
      }
      @keyframes zoomLoad2 {
        0% {
          transform: scale(1);
        }
        25% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.5);
        }
        75% {
          transform: scale(1);
        }
        100% {
          transform: scale(1);
        }
      }
      @keyframes zoomLoad3 {
        0% {
          transform: scale(1);
        }
        50% {
          transform: scale(1);
        }
        75% {
          transform: scale(1.5);
        }
        100% {
          transform: scale(1);
        }
      }
    }

    .bot-message {
      white-space: pre-wrap;
      .reasoning_content {
        font-size: 0.8em;
        padding-left: 10px;
        opacity: 0.4;
        border-left: 1px solid #666;
      }
    }
  }

  .restart {
    width: 160px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 8px;
    border-radius: 12px;
    cursor: pointer;
    color: #666;
    border: 1px solid #ddd;
    i {
      margin-right: 10px;
    }
  }
}

.question {
  p:first-child {
    font-size: 18px;
  }
  span {
    display: inline-block;
    font-size: 14px;
    padding: 2px 5px;
    margin: 0 5px;
    border: 1px solid rgb(21, 94, 239);
    border-radius: 10px;
    color: rgb(21, 94, 239);
    cursor: pointer;
    opacity: 0.8;
  }
}

.chat-input {
  width: 80%;
  margin: 20px 0 40px;
  background: #fff;
  border-radius: 20px;
  padding: 20px;
  border: 1px solid #e5e6eb;
  box-shadow: 0 4px 8px #0000000d;
  .input-content {
    overflow: hidden;
    border-radius: 20px;
    border: 1px solid #e5e6eb;
    .input-field {
      display: block;
      resize: none;
      width: 100%;
      padding: 10px;
      max-height: 200px;
      box-sizing: border-box;
      font-size: 20px;
      border: none;
      &:focus {
        outline: none;
      }
    }
  }
  .input-features {
    padding-top: 30px;
    display: flex;
    align-items: center;
    .web-search-toggle {
      display: flex;
      align-items: center;
      padding: 4px 8px;
      border-radius: 12px;
      cursor: pointer;
      color: #666;
      border: 1px solid #ddd;
      margin-right: 20px;
      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        opacity: 0.6;
        filter: grayscale(100%);
      }
    }

    .action-buttons {
      margin-left: auto;
      border-radius: 50%;
      background: rgb(53, 98, 244);
      width: 50px;
      height: 50px;
      line-height: 50px;
      text-align: center;

      img {
        width: 100%;
      }
      i {
        display: block;
        margin: 25%;
        width: 50%;
        height: 50%;
        border-radius: 5px;
        background: white;
      }
    }
  }
}

@media screen and (max-width: 768px), (pointer: coarse) {
  .content,
  .chat-input {
    margin: 3vw 0;
    padding: 3vw;
    font-size: 3vw;
  }

  .chat-input {
    .input-content {
      .input-field {
        font-size: 4vw;
      }
    }

    .input-features {
      padding-top: 3vw;
      .action-buttons {
        width: 8vw;
        height: 8vw;
        line-height: 8vw;
      }
    }
  }

  .model-name {
    font-size: 4vw;
  }

  .welcome {
    .welcome-logo {
      height: 6vw;
    }
    > p {
      font-size: 3vw;
    }
  }
  .question {
    padding: 0 20px;
    > p:first-child {
      font-size: 3vw;
    }
    span {
      font-size: 2.2vw;
    }
  }

  .content .message > div img {
    width: 40px;
  }
}
</style>
